import promoBannerStyles from './promo-banner';

var promoBanner = document.querySelector('.promo-banner-component');

if(promoBanner != null) {
  var cookieName = "PODSPromoBanner";
  var cookieIsDismissed = (cookies.getCookie(cookieName) ? cookies.getCookie(cookieName) : null);
  if (cookieIsDismissed == "true") {
    promoBanner.classList.add('closed');
  }
  attachClickEvent();
  function setCookies() {
    cookies.setCookie('PODSPromoBanner', true, 15);
  }
  function attachClickEvent() {
    document.getElementById('ClosePromoBanner').addEventListener("click", (e) => {
      e.preventDefault();
      setCookies();
      promoBanner.classList.add('closed');
    });
  }

  function getCookie(name) {
    var cookieArr = document.cookie.split(";");
    for(var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      if(name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function() {
    var PODSPromoBanner = getCookie('PODSPromoBanner');
    if (PODSPromoBanner != 'true') {
      promoBanner.classList.remove('closed');
    }
  }, false);
}
